const document_signing_status = {
    "PROGRESS" : "En cours",
    "SIGNED" : "Signé",
    "REFUSED" : "Refusé",
    "EXPIRED" : "Expiré"
};

export default document_signing_status;
